"use client";

import dynamic from "next/dynamic";

import type { SliderExpressiveProps } from "./SliderExpressive";

const SliderExpressive = dynamic(() => import("./SliderExpressive").then(mod => mod.SliderExpressive));

export default function SliderExpressiveWrapper(props: SliderExpressiveProps) {
  return <SliderExpressive {...props} />;
}
